import { ButtonDropdown } from '../ButtonDropdown';
import React from 'react';

export interface ISizePerPageProps {
  options: { page: number; text: string }[];
  currSizePerPage: number;
  onSizePerPageChange: (sizePerPage: number) => void;
}

export const SizePerPage: React.FC<ISizePerPageProps> = ({ options, currSizePerPage, onSizePerPageChange }) => (
  <ButtonDropdown
    intent={'ghost'}
    isInline
    items={options.map((option) => ({
      children: option.text,
      onClick: () => {
        onSizePerPageChange(option.page);
      },
    }))}
  >
    Showing {currSizePerPage} per page.
  </ButtonDropdown>
);
